import {
    SET_LOCATION_STRATEGY,
    STRATEGY_LIST,
} from '../../constants/actionType';

export const strategyListReduxAction = ({ strategyData }) => async dispatch => {
    try {
        dispatch({
            type: STRATEGY_LIST,
            strategyData
        });
    } catch (err) {
    } finally {

    }
};

export const setLocationReduxAction = ({ includedLocation, excludedLocation }) => async dispatch => {
    try {
        console.log("includedLocation", includedLocation)
        console.log("excludedLocation", excludedLocation)

        let locationMap = { includedLocation: includedLocation, excludedLocation: excludedLocation };
        dispatch({
            type: SET_LOCATION_STRATEGY,
            locationMap
        });
    } catch (err) {
    } finally {

    }
};